export const useCurationParts = (
  editstate: CurationEditState = null,
  def : CurationPartDefinition = null,
) => {

  const { getCurationPartsName } = useCurationEditor()

  const _editstate = editstate
  const _def = def

  const partName = computed((): LangString => {
    if (_def) {
      return getCurationPartsName(_def)
    }
    return {}
  })

  const isNote = computed((): boolean => {
    if (_editstate) {
      return _editstate.mode === 'note'
    }
    return false
  })

  const isNoLang = computed((): boolean => {
    if (_editstate) {
      return _editstate.mode !== 'full'
    }
    return false
  })

  const editorStyle = computed((): object => {
    if (_editstate && _def) {
      if (_editstate.editors && _editstate.editors[_def.cpid]) {
        return { 'border-color': _editstate.editors[_def.cpid].color }
      }
    }
    return null
  })

  return {
    partName,
    isNote,
    isNoLang,
    editorStyle,
  }
}

